// Import our CSS
import 'aos/src/sass/aos.scss';
import styles from '../scss/app.scss';

//Import vue components
import Vuex from 'vuex'
import AOS from 'aos';
import VueEqualHeights from './plugins/EqualHeights'
import VueScrollTo from 'vue-scrollto'
import VueAgile from 'vue-agile'
import * as VueGoogleMaps from "vue2-google-maps";
import Datepicker from 'vuejs-datepicker';
import { en, da, fi, sv, nbNO } from 'vuejs-datepicker/dist/locale'

//Custom vue components
import CookiePopup from './components/CookiePopup.vue'
import YoutubePopup from "./components/YoutubePopup.vue";
import TextPopup from "./components/TextPopup.vue";
import ImagePopup from "./components/ImagePopup.vue";
import EstimationCalculator from "./components/EstimationCalculator.vue";
import DealersMap from "./components/DealersMaps.vue";
import HiddenTextarea from "./components/HiddenTextarea.vue";
import FaqList from "./components/FaqList.vue";
import Checkout from "./components/Checkout.vue";
import SubscriptionManager from "./components/SubscriptionManager.vue";
import ApolloClient from 'apollo-boost'
import VueApollo from 'vue-apollo'
import axios from 'axios';

let getUrl = window.location;
const baseUrl = getUrl.protocol + "//" + getUrl.host + "/__graphql";
const apolloClient = new ApolloClient({
	uri: baseUrl
})

// App main
const main = async () => {
	// Async load the vue module
	const { default: Vue } = await import(/* webpackChunkName: "vue" */ 'vue');

	//Enable Equal Heights plugin
	Vue.use(VueEqualHeights)

	//Enable Vuex store
	Vue.use(Vuex)

	//Enable Vue agile
	Vue.use(VueAgile)

	//Enable smoothscroll
	Vue.use(VueScrollTo, {
		container: "body",
		duration: 1200,
		easing: [.29, .56, .42, 1],
		offset: 0,
		force: true,
		cancelable: true,
		x: false,
		y: true
	})

	//Enable Googlemaps
	Vue.use(VueGoogleMaps, {
		load: {
			key: "AIzaSyBa6dywLTgpXB_IkzoIZl3k878HcFJG2ZI",
		}
	});

	//Enable apollo
	Vue.use(VueApollo)

	const apolloProvider = new VueApollo({
		defaultClient: apolloClient,
	})

	//Vuex config and mutations
	const store = new Vuex.Store({
		state: {
			isMobileMenuOpen: false,
			isCallRequestOpen: false,
			isMessageRequestOpen: false,
			isLanguageSelectorOpen: false,
			isLoginSelectorOpen: false,
			scrollPosition: 0,
			isVideoOpen: false,
			isTextOpen: false,
			isImageOpen: false,
			textMessage: '',
			imagePopupUrl: '',
			videoId: {
				type: String,
				default: '',
			},
			isMounted: false
		},
		mutations: {
			closeMobileMenu(state) {
				state.isMobileMenuOpen = false
			},
			openMobileMenu(state) {
				state.isMobileMenuOpen = true
			},
			adjustScrollPosition(state, position) {
				state.scrollPosition = position
			},
			showVideo(state, id) {
				state.videoId = id
				state.isVideoOpen = true
			},
			closeVideo(state) {
				state.isVideoOpen = false
			},
			setTextMessage(state, message) {
				state.textMessage = message
			},
			setTextPopupState(state, popupState) {
				state.isTextOpen = popupState
			},
			setCallRequestState(state, value) {
				state.isCallRequestOpen = value
			},
			setMessageRequestState(state, value) {
				state.isMessageRequestOpen = value
			},
			setLanguageSelectorState(state, value) {
				state.isLanguageSelectorOpen = value
			},
			setLoginSelectorState(state, value) {
				state.isLoginSelectorOpen = value
			},
			setImagePopupState(state, value) {
				state.isImageOpen = value
			},
			setImageUrl(state, value) {
				state.imagePopupUrl = value
			}
		}
	});

	// Create our vue instance
	const vm = new Vue({
		el: "#app",
		delimiters: ['${', '}'],
		apolloProvider,
		store,
		components: {
			YoutubePopup,
			CookiePopup,
			HiddenTextarea,
			TextPopup,
			ImagePopup,
			DealersMap,
			FaqList,
			Datepicker,
			EstimationCalculator,
			Checkout,
			SubscriptionManager
		},
		data() {
			return {
				agileMobileOptions: {
					responsive: [
						{
							breakpoint: 549,
							settings: {
								slidesToShow: 2
							}
						},

						{
							breakpoint: 900,
							settings: {
								slidesToShow: 3,
							}
						}
					]
				},
				featuredItemsAgile: {
					responsive: [
						{
							breakpoint: 679,
							settings: {
								slidesToShow: 2
							}
						},

						{
							breakpoint: 1024,
							settings: {
								slidesToShow: 3,
							}
						}
					]
				},
				datepickeren: en,
				datepickerda: da,
				datepickerfi: fi,
				datepickersv: sv,
				datepickernn: nbNO,
				datepickerSettings: {
					disabledDates: {
						to: new Date(), // Disable all dates after specific date
						days: [6, 0], // Disable Saturday's and Sunday's
					},
					openDate: new Date(+new Date() + 86400000)
				}

			}
		},
		methods: {
			setCallRequestState: function (value) {
				this.toggleBodyScroll(value);
				store.commit('setCallRequestState', value)
			},
			setMessageRequestState: function (value) {
				this.toggleBodyScroll(value);
				store.commit('setMessageRequestState', value)
			},
			toggleBodyScroll(value) {
				let bodyClass = 'modalOpen'

				if (this.isMobileUnit()) {
					bodyClass += ' isMobile'
				}

				if (value) {
					document.documentElement.className = bodyClass;
					document.body.scroll = "no";
				} else {
					document.documentElement.className = '';
					document.body.scroll = "yes";
				}
			},
			isMobileUnit() {
				let check = false;
				(function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
				return check;
			},
			toggleLanguageSelectorState: function () {
				switch (store.state.isLanguageSelectorOpen) {
					case true:
						store.commit('setLanguageSelectorState', false)
						break

					case false:
						store.commit('setLanguageSelectorState', true)
						break

					default:
						store.commit('setLanguageSelectorState', false)
						break
				}
			},
			toggleLoginSelectorState: function () {
				console.log('tet')
				switch (store.state.isLoginSelectorOpen) {
					case true:
						store.commit('setLoginSelectorState', false)
						break

					case false:
						store.commit('setLoginSelectorState', true)
						break

					default:
						store.commit('setLoginSelectorState', false)
						break
				}
			},
			openVideo(id) {
				store.commit('showVideo', id)
			},
			showTextBox(text) {
				store.commit('setTextMessage', text)
				store.commit('setTextPopupState', true)
			},
			showImage(url) {
				store.commit('setImageUrl', url)
				store.commit('setImagePopupState', true)
			},
			toggleMobileMenu: function (event) {
				switch (store.state.isMobileMenuOpen) {
					case true:
						store.commit('closeMobileMenu')
						break

					case false:
						store.commit('openMobileMenu')
						break

					default:
						store.commit('closeMobileMenu')
						break
				}

				store.commit('setLanguageSelectorState', false)
			},
			goToSlide: function (ref, index) {
				let paginations = this.$refs[ref + 'Navigator'].childNodes
				var pagination_items = [];
				for (var i = 0; i < paginations.length; i++) {
					// Add all the <li> nodes to an array, skip the text nodes
					if (paginations[i].nodeType != 3) {
						pagination_items.push(paginations[i]);
					}
				}
				pagination_items.forEach(function (el) {
					if (el.classList && el.classList.contains('active')) {
						el.classList.remove('active');
					}
				})
				pagination_items[index].classList.add('active')

				let slides = this.$refs[ref + 'Slider'].childNodes
				var slide_items = [];
				for (var i = 0; i < slides.length; i++) {
					// Add all the <li> nodes to an array, skip the text nodes
					if (slides[i].nodeType != 3) {
						slide_items.push(slides[i]);
					}
				}
				slide_items.forEach(function (el) {
					if (el.classList && el.classList.contains('active')) {
						el.classList.remove('active');
					}
				})
				slide_items[index].classList.add('active')
			},
			handleScroll: function (event) {
				const app = document.getElementById('app')
				let scrollPosY = window.pageYOffset | document.body.scrollTop;
				if (app) {
					if (scrollPosY > 35) {

						if (!app.classList.contains('scrolled')) {
							app.classList.add('scrolled')
						}

					} else if (scrollPosY <= 35) {
						app.classList.remove('scrolled')
					}

				}

				store.state.scrollPosition = scrollPosY;

				//Close language selector
				switch (store.state.isLanguageSelectorOpen) {
					case true:
						store.commit('setLanguageSelectorState', false)
						break
				}
			},
			submitForm: function (event) {
				event.preventDefault()

				//Show loader
				event.target.parentNode.classList.add('submitting')
				event.target.parentNode.classList.remove('success')
				event.target.parentNode.classList.remove('error')

				const formData = new FormData();
				const formToJSON = elements => [].reduce.call(elements, (data, element) => {
					formData.append(element.name, element.value)
				}, {});

				const form = event.target
				formToJSON(form.elements);

				let getUrl = window.location;
				const baseUrl = getUrl.protocol + "//" + getUrl.host;

				axios.post(baseUrl, formData)
					.then(response => {
						event.target.reset()
						event.target.parentNode.classList.remove('submitting')
						event.target.parentNode.classList.add('success')
					})
					.catch(error => {
						//Show error message
						event.target.parentNode.classList.remove('submitting')
						event.target.parentNode.classList.add('error')
					});
			}
		},
		computed: {
			isMobileMenuOpen() {
				return store.state.isMobileMenuOpen
			},
			isCallRequestOpen() {
				return store.state.isCallRequestOpen
			},
			isMessageRequestOpen() {
				return store.state.isMessageRequestOpen
			},
			isVideoOpen() {
				return store.state.isVideoOpen
			},
			isTextOpen() {
				return store.state.isTextOpen
			},
			isImageOpen() {
				return store.state.isImageOpen
			},
			videoId() {
				return store.state.videoId
			},
			textMessage() {
				return store.state.textMessage
			},
			imagePopupUrl() {
				return store.state.imagePopupUrl
			},
			isMounted() {
				return store.state.isMounted
			},
			isLanguageSelectorOpen() {
				return store.state.isLanguageSelectorOpen
			},
			isLoginSelectorOpen() {
				return store.state.isLoginSelectorOpen
			}
		},
		created() {
			AOS.init({
				easing: 'ease-in-out',
				delay: 0,
				once: true,
				startEvent: 'load',
				anchorPlacement: 'top-bottom',
				offset: 0
			})

			window.addEventListener('scroll', this.handleScroll);
		},
		destroyed() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		mounted() {
			window.onload = function () {
				setTimeout(function () {
					let contactblock = document.querySelector(".l-contactblock__holder");
					if (contactblock) {
						contactblock.classList.remove("scrolled");
					}
				}, 950);
			};

			this.$nextTick(function () {
				store.state.isMounted = true;
			})
		},
	});

	return vm;
};

// Execute async function
main().then((vm) => {

});

// Accept HMR as per: https://webpack.js.org/api/hot-module-replacement#accept
if (module.hot) {
	module.hot.accept();
}
